import { ArrowRight, Terminal } from "lucide-react";

export default function Hero({ onGetStarted }) {
  return (
    <section id="top" className="noise-overlay circuit-bg relative overflow-hidden pt-16">
      <div className="scanline" />
      <div
        className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full opacity-25 blur-[120px]"
        style={{ background: "#00f0ff" }}
      />
      <div
        className="pointer-events-none absolute bottom-0 left-0 h-96 w-96 rounded-full opacity-15 blur-[120px]"
        style={{ background: "#ff003c" }}
      />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-6 pb-24 pt-16 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:px-10 lg:pb-32 lg:pt-24">
        <div>
          <p className="font-mono-tech mb-6 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#ff003c] text-glow-magenta">
            <Terminal size={14} /> Systems online // Hospitals & Restaurants
          </p>
          <h1 className="font-display text-4xl font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            Websites that{" "}
            <span className="text-[#00f0ff] text-glow-cyan">win clients</span>.
            <br />
            Apps that{" "}
            <span className="text-[#ff003c] text-glow-magenta">run the work</span>.
          </h1>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
            Gsoftware builds, updates, and fully manages websites and mobile apps for
            hospitals and restaurants — professional digital presence that attracts more
            clients, and custom software that automates processes and improves workflows.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={onGetStarted}
              data-testid="hero-get-started-btn"
              className="glitch-hover group flex items-center gap-2 border border-[#00f0ff] bg-[#00f0ff]/10 px-8 py-4 font-mono-tech text-sm font-bold uppercase tracking-widest text-[#00f0ff] transition-shadow duration-300 hover:glow-cyan"
            >
              Get Started
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <a
              href="#plans"
              data-testid="hero-view-plans-btn"
              className="glitch-hover border border-[#ff003c]/60 px-8 py-4 font-mono-tech text-sm font-bold uppercase tracking-widest text-[#ff003c] transition-shadow duration-300 hover:glow-magenta"
            >
              View Plans
            </a>
          </div>
          <div className="mt-12 flex flex-wrap gap-10">
            {[
              ["24/7", "Tier 3 support"],
              ["100%", "Managed for you"],
              ["2", "Industries mastered"],
            ].map(([v, l]) => (
              <div key={l}>
                <p className="font-display text-2xl font-bold text-white">{v}</p>
                <p className="font-mono-tech mt-1 text-[11px] uppercase tracking-widest text-white/40">{l}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="float-slow relative mx-auto w-full max-w-md">
          <div className="absolute -inset-4 rounded-sm border border-[#00f0ff]/20" />
          <div className="absolute -inset-8 rounded-sm border border-[#ff003c]/10" />
          <img
            src="/assets/logo.jpg"
            alt="Gsoftware neon circuit G logo"
            data-testid="hero-logo"
            className="flicker glow-cyan relative w-full rounded-sm border border-white/10 object-cover"
          />
          <div className="mt-4 flex items-center justify-between font-mono-tech text-[10px] uppercase tracking-widest text-white/30">
            <span>build // deploy // manage</span>
            <span className="text-[#00f0ff]">v3.0 stable</span>
          </div>
        </div>
      </div>
    </section>
  );
}
